/**
 * @generated SignedSource<<4cb21b17e96822afd9b7937077d42490>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RevenueGroup = "CLUSTERS" | "DATABASES" | "INSTANCES_AND_PROJECTS" | "OTHER" | "SERVICES" | "STORAGE_AND_TRAFFIC" | "%future added value";
export type AnalysisIncomeViewQuery$variables = {
  from: string;
  serviceIdentifier?: string | null | undefined;
  serviceType?: string | null | undefined;
  to: string;
};
export type AnalysisIncomeViewQuery$data = {
  readonly monthlyRevenue: {
    readonly customers: ReadonlyArray<{
      readonly amount: number;
      readonly amounts: ReadonlyArray<number>;
      readonly customerAccountIdentifier: string;
      readonly customerName: string;
    }>;
    readonly groups: ReadonlyArray<{
      readonly amount: number;
      readonly amounts: ReadonlyArray<number>;
      readonly costCategories: ReadonlyArray<{
        readonly amount: number;
        readonly amounts: ReadonlyArray<number>;
        readonly costCategoryIdentifier: string;
      }>;
      readonly group: RevenueGroup;
    }>;
    readonly months: ReadonlyArray<{
      readonly amount: number;
      readonly customerCount: number;
      readonly isComplete: boolean;
      readonly month: string;
      readonly subscriptionCount: number;
    }>;
    readonly services: ReadonlyArray<{
      readonly label: string;
      readonly serviceIdentifier: string;
    }>;
  };
};
export type AnalysisIncomeViewQuery = {
  response: AnalysisIncomeViewQuery$data;
  variables: AnalysisIncomeViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "serviceIdentifier"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "serviceType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amounts",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "from",
        "variableName": "from"
      },
      {
        "kind": "Variable",
        "name": "serviceIdentifier",
        "variableName": "serviceIdentifier"
      },
      {
        "kind": "Variable",
        "name": "serviceType",
        "variableName": "serviceType"
      },
      {
        "kind": "Variable",
        "name": "to",
        "variableName": "to"
      }
    ],
    "concreteType": "MonthlyRevenue",
    "kind": "LinkedField",
    "name": "monthlyRevenue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RevenueMonthTotal",
        "kind": "LinkedField",
        "name": "months",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "month",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isComplete",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subscriptionCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RevenueGroupMonthlyTotals",
        "kind": "LinkedField",
        "name": "groups",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "group",
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RevenueCostCategoryMonthlyTotals",
            "kind": "LinkedField",
            "name": "costCategories",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costCategoryIdentifier",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RevenueCustomerMonthlyTotals",
        "kind": "LinkedField",
        "name": "customers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAccountIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerName",
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RevenueServiceTotal",
        "kind": "LinkedField",
        "name": "services",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisIncomeViewQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AnalysisIncomeViewQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "8d8109ea8d282138bd472668efb3dff1",
    "id": null,
    "metadata": {},
    "name": "AnalysisIncomeViewQuery",
    "operationKind": "query",
    "text": "query AnalysisIncomeViewQuery(\n  $from: String!\n  $to: String!\n  $serviceType: String\n  $serviceIdentifier: String\n) {\n  monthlyRevenue(from: $from, to: $to, serviceType: $serviceType, serviceIdentifier: $serviceIdentifier) {\n    months {\n      month\n      isComplete\n      amount\n      customerCount\n      subscriptionCount\n    }\n    groups {\n      group\n      amount\n      amounts\n      costCategories {\n        costCategoryIdentifier\n        amount\n        amounts\n      }\n    }\n    customers {\n      customerAccountIdentifier\n      customerName\n      amount\n      amounts\n    }\n    services {\n      serviceIdentifier\n      label\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d0167eb93ef9fb85b14bbbeb0c0c726";

export default node;
